mutation RemoveStaffMember($accountId: ID!) {
  result: StreamToolsRemoveStaffMember(accountId: $accountId) {
    accountId
    removed
  }
}
